if (!customElements.get("product-mini-slider")) {
  customElements.define(
    "product-mini-slider",
    class ProductMiniSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector("[data-mini-slider-track]");
        if (!this.track) return;

        this.dots = Array.from(this.querySelectorAll("[data-mini-slider-dot]"));
        this.prevButton = this.querySelector("[data-mini-slider-prev]");
        this.nextButton = this.querySelector("[data-mini-slider-next]");
        this.controller = new AbortController();

        const options = { signal: this.controller.signal };
        this.track.addEventListener("scroll", () => this.scheduleSync(), {
          ...options,
          passive: true,
        });
        this.prevButton?.addEventListener(
          "click",
          (event) => this.handleStep(event, -1),
          options,
        );
        this.nextButton?.addEventListener(
          "click",
          (event) => this.handleStep(event, 1),
          options,
        );
        this.dots.forEach((dot, index) => {
          dot.addEventListener(
            "click",
            (event) => {
              event.stopPropagation();
              this.goTo(index);
            },
            options,
          );
        });

        this.sync();
      }

      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      get count() {
        return this.dots.length || 1;
      }

      get index() {
        const width = this.track.clientWidth;
        if (!width) return 0;
        return Math.min(
          Math.round(this.track.scrollLeft / width),
          this.count - 1,
        );
      }

      handleStep(event, direction) {
        event.stopPropagation();
        this.goTo(this.index + direction);
      }

      goTo(index) {
        const target = Math.min(Math.max(index, 0), this.count - 1);
        this.track.scrollTo({
          left: target * this.track.clientWidth,
          behavior: "smooth",
        });
      }

      scheduleSync() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.sync();
        });
      }

      sync() {
        const current = this.index;
        this.dots.forEach((dot, index) => {
          dot.classList.toggle("mini-slider__dot--active", index === current);
          dot.setAttribute("aria-current", index === current ? "true" : "false");
        });
        if (this.prevButton) this.prevButton.disabled = current === 0;
        if (this.nextButton) this.nextButton.disabled = current === this.count - 1;
      }
    },
  );
}
